module.exports = __webpack_public_path__ + "static/media/production-catering.217d3131.jpg";